import {DomainKeys} from '../../state/types/state.js';
import {CallRequest, SubscribeRequest} from './types/requests.js';
import {isPeerVisible, JoinedPeer} from '../../state/peers.js';
import {agmInvocationFailure} from './constants.js';
import {throwReason} from '../../reason.js';

export function validate(caller: JoinedPeer<DomainKeys.Agm>, callee: JoinedPeer<DomainKeys.Agm>, request: SubscribeRequest | CallRequest) {
    const {server_id: serverId, method_id: methodId, arguments: args, arguments_kv: argsKv} = request;
    if ((caller.id !== callee.id) && !isPeerVisible(DomainKeys.Agm, caller, callee)) {
        throwReason(agmInvocationFailure, 'Unable to invoke methods across different users');
    }
    if (!caller[DomainKeys.Agm].methods?.[serverId]?.[methodId]) {
        throwReason(agmInvocationFailure, `Unable to find method with id ${methodId} on server id ${serverId} registered with this peer`);
    }
    if (args && argsKv) {
        throwReason(agmInvocationFailure, `Cant use positional and by-name arguments at the same time`);
    }
}
